import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("canvas", { id: "theCanvas" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tooltip = _resolveComponent("el-tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_tooltip, {
      visible: _ctx.popoverIsVisible,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.popoverIsVisible) = $event)),
      content: "sasat",
      placement: "top",
      "popper-class": "my-popper",
      "virtual-ref": _ctx.popoverTriggerRef,
      "virtual-triggering": "",
      trigger: "click"
    }, {
      content: _withCtx(() => [
        (_ctx.popoverData)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createElementVNode("span", null, _toDisplayString(_ctx.popoverData.transcription), 1),
              _hoisted_2,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popoverData.labels, (labelData) => {
                return (_openBlock(), _createElementBlock("span", {
                  key: labelData.label
                }, _toDisplayString(labelData.label) + " - точность " + _toDisplayString(labelData.accuracy) + "% ", 1))
              }), 128))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "virtual-ref"]),
    _createElementVNode("canvas", {
      id: "theCanvasOverlay",
      style: {"position":"absolute","left":"0","top":"0"},
      onMousemove: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onOverlayMouseMove && _ctx.onOverlayMouseMove(...args)))
    }, null, 32),
    _hoisted_3
  ]))
}